import React, { useState, useEffect } from 'react';
import bcrypt from 'bcryptjs';
import catNuhuhGif from '../assets/SecretPin/cat_nuhuh.gif';
import catWhatsgoingonGif from '../assets/SecretPin/cat_whatgoingon.gif';

function SecretPin({ onNavigate }) {
  const [value, setValue] = useState('');
  const [message, setMessage] = useState('');
  const [wrongPin, setWrongPin] = useState(false);
  const [correctPin, setCorrectPin] = useState(false);

  const onCorrect = () => {
    onNavigate?.('ready');
  };

  useEffect(() => {
    if (!correctPin) return;
    const timer = setTimeout(onCorrect, 3000);
    return () => clearTimeout(timer);
  }, [correctPin, onNavigate]);

  const handleConfirm = () => {
    const hashedPin = "$2a$12$58SbrJvKjHTzCrXXG.CWwezPEQbLwkOs5tZsfj7ZMQWPlhx3aDOPi";
    if (!hashedPin) {
      setMessage('PIN not configured - Oopsies [#E_001]');
      setWrongPin(false);
      return;
    }
    const match = bcrypt.compareSync(value, hashedPin);
    setWrongPin(!match);
    setCorrectPin(match);
  };

  return (
    <div className="dashboard">
      <div className="home__center startup__stack">
        <span className="secretpin__title">PIN</span>
        <input
          type="password"
          className="dashboard__input secretpin__input"
          placeholder=""
          autoComplete="off"
          value={value}
          onChange={(e) => { setValue(e.target.value); setWrongPin(false); }}
          onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
        />
        <button
          type="button"
          className="dashboard__button dashboard__button--primary home__button"
          onClick={handleConfirm}
        >
          {correctPin ? 'Processing...' : 'Confirm'}
        </button>
        {wrongPin && <img src={catNuhuhGif} alt="" className="secretpin__gif" />}
        {correctPin && <img src={catWhatsgoingonGif} alt="" className="secretpin__gif" />}
        {message && <span className="secretpin__message">{message}</span>}
      </div>
    </div>
  );
}

export default SecretPin;
